import React, { ReactNode } from 'react'

import * as Styles from './HeaderAction.styles'
import { BaseButtonProps, LinkButtonProps } from '@sketch/components'

type HeaderActionProps = OmitSafe<BaseButtonProps, 'icon'> & {
  icon: ReactNode
}

/**
 * @TODO check if this component can be made part of the design system
 * https://github.com/sketch-hq/Cloud/issues/12901
 */
export function HeaderActionButton({
  children,
  icon,
  ...rest
}: HeaderActionProps) {
  return (
    <Styles.ButtonAction {...rest}>
      {children}
      <Styles.IconContainer>{icon}</Styles.IconContainer>
    </Styles.ButtonAction>
  )
}

type ActionLinkProps = OmitSafe<LinkButtonProps, 'icon'> & {
  icon: ReactNode
}

export function HeaderActionLink({ children, icon, ...rest }: ActionLinkProps) {
  return (
    <Styles.LinkAction {...rest}>
      {children}
      <Styles.IconContainer>{icon}</Styles.IconContainer>
    </Styles.LinkAction>
  )
}
